export const defaultStyle = {
    wrapper: "relative w-full z-[10]",
}
